import React from "react";
import { TextField, Button, Typography, CircularProgress } from "@mui/material";
import { gql, useMutation } from "@apollo/client";
import { useNotification } from "../../Context/notificationContext";

// Define the mutation of update user password
const UPDATE_USER_PASSWORD = gql`
  mutation changePassword(
    $Id: ID!
    $oldPassword: String!
    $newPassword: String!
  ) {
    changePassword(
      Id: $Id
      oldPassword: $oldPassword
      newPassword: $newPassword
    )
  }
`;

const UpdateUserPassword = ({ id }) => {
  const [changePassword, { loading }] = useMutation(UPDATE_USER_PASSWORD);
  const {showNotification} = useNotification();
  const [oldPassword, setOldPassword] = React.useState("");
  const [newPassword, setNewPassword] = React.useState("");
  const [confirmNewPassword, setConfirmNewPassword] = React.useState("");

  const handleUpdateProfile = async () => {
    if (!oldPassword || !newPassword || !confirmNewPassword) {
      showNotification("error", "Please fill all fields");
      return;
    }
    const passwordRegex =
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/;
    if (!passwordRegex.test(newPassword)) {
      showNotification(
        "error",
        "New password must be at least 8 characters long, contain at least one letter, one number, and one special character"
      );
      return;
    }
    if (newPassword !== confirmNewPassword) {
      showNotification(
        "error",
        "New password and confirm password do not match"
      );
      return;
    }
    try {
      const response = await changePassword({
        variables: { Id: id, oldPassword, newPassword },
      });
      console.log("response", response);
      if (response?.data?.updateUser) {
        showNotification("success", "Password updated");
      }
    } catch (error) {
      console.error("Failed to update user password:", error);
      showNotification("error", error.message);
    }
  };

  return (
    <form
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Typography
        variant="h6"
        component="h1"
        gutterBottom
        style={{ fontSize: "0.9rem", color: "#f2f2f2" }}
      >
        Change/Update Password
      </Typography>
      <TextField
        label="Old Password"
        type="password"
        variant="outlined"
        margin="normal"
        onChange={(e) => setOldPassword(e.target.value)}
        fullWidth
      />
      <TextField
        label="New Password"
        type="password"
        variant="outlined"
        margin="normal"
        onChange={(e) => setNewPassword(e.target.value)}
        fullWidth
      />
      <TextField
        label="Confirm New Password"
        type="password"
        variant="outlined"
        margin="normal"
        onChange={(e) => setConfirmNewPassword(e.target.value)}
        fullWidth
      />
      <Button
        variant="contained"
        color="primary"
        size="large"
        style={{ marginTop: "20px" }}
        onClick={handleUpdateProfile}
      >
        {loading ? <CircularProgress size={24} /> : "Update"}
      </Button>
    </form>
  );
};

export default UpdateUserPassword;
